import axios from 'axios'
import store from '@/store/index'
import i18n from '@/i18n'

function handlingError(error) {
  try {
    console.log('index', error)
    const info = i18n.t('services.networkError')
    let response,
      message = null

    if (error.response) response = error.response
    else if (error.message) response = error.message
    else response = error

    if (response && response.data) {
      if (response.status == 422) {
        message = i18n.t('login.corrigir') + '<br>'
        Object.keys(response.data.error).forEach((key) => {
          message += response.data.error[key] + '<br>'
        })
      } else {
        if (response.data.error) {
          if (response.data.error.message)
            message =
              response.data.error.error + ' ' + response.data.error.message
          else message = response.data.error
        } else {
          message =
            response.status + ' ' + response.statusText + '<br>' + error404()
        }
      }
    } else {
      console
      message =
        response == 'Sessão expirada!'
          ? i18n.t('services.sessionExpired')
          : response + '<br>' + info
    }
    return Promise.reject(message)
  } catch (error) {
    console.error(error)
  }
}

const http = axios.create({
  baseURL: `${localStorage.getItem('API_URL') ||
    process.env.VUE_APP_BASEURL ||
    'http://localhost:8000/api/'}`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})
http.interceptors.request.use(
  async function(config) {
    /*
     * Atualizar a baseURL do axios, porque sempre vai estar com o endereço de API de
     * quando foi criado a instância. Quando informa um novo endereço de API, o axios continua
     * com o mesmo endereço de antes
     */
    const apiURL = store.state.systemModule.apiURL
    if (apiURL !== config.baseURL) config.baseURL = apiURL

    let userType = store.state.authModule.session.type
    let authType = userType == 'common' ? 'auth' : 'auth-guests'
    let urlLogin = config.baseURL + authType + '/login'
    let urlMe = config.baseURL + authType + '/me'
    let urlLogout = config.baseURL + authType + '/logout'
    let urlAuthorization = config.baseURL + 'auth-guests/authorization'
    let authUser = store.state.authModule.authUser
    /*
     * Atualiza o header das requisições para incluir o token e filial
     * Para a rota auth/me(urlMe) o token está como payload, e não no header
     */
    if (authUser && config.url !== urlMe) {
      /*
       * Validação se o token está inválido, e o usuário está fazendo requisição
       * para rota diferente do login ou logout
       */
      if (
        store.state.authModule.tokenInvalid &&
        config.url !== urlLogin &&
        config.url !== urlLogout
      ) {
        /*
         * Para usuário common, sempre será requisitado relogin quando o token é invalido
         * Para os usuários guest, apenas será requisitado relogin apenas se a rota
         * for diferente de auth-guests/authorization(urlAuthorization), que não necessita de autenticação
         */
        if (
          userType == 'common' ||
          (userType == 'guest' && config.url !== urlAuthorization)
        ) {
          await store.dispatch('authModule/requestRelogin', true)
          await store.dispatch('authModule/setTokenInvalid', true)
          return Promise.reject(i18n.t('services.sessionExpired'))
        }
      }
      const token = `Bearer ${authUser.access_token || ''}`
      const filial = authUser.filial
      config.headers.Authorization = token
      config.headers.filial = filial
      if (authUser.guest) config.headers.guest = authUser.guest
    }
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  (response) => {
    return response
  },
  async function(error) {
    const originalRequest = (await error) && error.config ? error.config : null
    const errorStatus = error && error.response ? error.response.status : null
    const errorText =
      error && error.response ? error.response.data?.error : null
    const urlLogout =
      error && error.config ? error.config.baseURL + 'auth/logout' : ''

    // const liberarRotas = ['ifood']
    // const urlAtual = error.config.url.split('/')
    // const checkUrl = liberarRotas.filter((e) => e == urlAtual[0])

    // if (checkUrl.length > 0) return error.response

    /*
     * Quando a requisição tem status 401 e statusText,
     * será gerado uma nova requisição para gerar um novo token automaticamente
     */
    if (errorStatus === 401 && errorText === 'Token is Expired') {
      const access_token = await refreshAccessToken()
      let user = ''
      user = JSON.parse(localStorage.getItem('authUser'))
      if (user && user != '') {
        user.access_token = access_token.data.token
        localStorage.setItem('authUser', JSON.stringify(user))
      }
      await store.dispatch('authModule/updateAuthUser', user)
      originalRequest.headers.Authorization =
        'Bearer ' + access_token.data.token
      return axios(originalRequest)
      /*
       * Quando expirar o tempo de realizar o refresh automático do token,
       * será solicitado o relogin para o usuário
       */
    } else if (
      errorStatus === 401 &&
      (errorText === 'Token is Invalid' || errorText === 'Unauthenticated.')
    ) {
      if (error.config.url == urlLogout)
        store.dispatch('authModule/clearAuthUser')
      else {
        await store.dispatch('authModule/requestRelogin', true)
        await store.dispatch('authModule/setTokenInvalid', true)
        return handlingError(error)
      }
    }
    return handlingError(error)
  }
)

async function refreshAccessToken() {
  return await http.post('/auth/refresh')
}

function error404() {
  return i18n.t('services.error404')
}

export default http
